<template>
    <span class="messages-square-outline-icon">
        <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            :stroke="stroke"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16 10a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 14.286V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"
            />
            <path
                d="M20 9a2 2 0 0 1 2 2v10.286a.71.71 0 0 1-1.212.502l-2.202-2.202A2 2 0 0 0 17.172 19H10a2 2 0 0 1-2-2v-1"
            />
        </svg>
    </span>
</template>

<script>
export default {
    name: 'IconMessagesSquareOutline',
    props: {
        stroke: {
            type: String,
            default: 'currentColor',
        },
    },
};
</script>

<style scoped>
/* See IconPlayOutline.vue for why the wrapper needs to be a flex container
   itself: a plain <span> as a flex/grid item doesn't center its own
   inline-level svg content vertically. */
.messages-square-outline-icon {
    display: inline-flex;
    align-items: center;
}
</style>
